module.exports = __webpack_public_path__ + "static/media/logo-agep-simple.35fc6e42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/logo-agep-simple.svg
// module id = 1515
// module chunks = 0